import { render, staticRenderFns } from "./CustomDisabledCheckbox.vue?vue&type=template&id=2d99d76d&scoped=true&"
import script from "./CustomDisabledCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomDisabledCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CustomDisabledCheckbox.vue?vue&type=style&index=0&id=2d99d76d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d99d76d",
  null
  
)

export default component.exports